"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFormData = void 0;
const tslib_1 = require("tslib");
const isDate_1 = tslib_1.__importDefault(require("lodash/isDate"));
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
const isString_1 = tslib_1.__importDefault(require("lodash/isString"));
const isBoolean_1 = tslib_1.__importDefault(require("lodash/isBoolean"));
const isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
const isPlainObject_1 = tslib_1.__importDefault(require("lodash/isPlainObject"));
const ensureCase_1 = require("./ensureCase");
const toFormData = (value, config = {}, legacy = {}) => {
    let { _method, convertCase, removeNull = true, removeUndefined = true, booleanAsNumber = true, dateToISOString = true, removeFalsy = true, removeEmptyString = true, } = config;
    // Change case of keys
    convertCase = convertCase || (legacy === null || legacy === void 0 ? void 0 : legacy.convertCase);
    value = (0, ensureCase_1.ensureCase)(value, convertCase);
    // _method
    if (_method)
        value._method = _method;
    const formData = new FormData();
    const traverse = (value, key) => {
        // Recursive call for nested arrays
        if ((0, isArray_1.default)(value)) {
            value.forEach((v, index) => {
                traverse(v, key ? `${key}[${index}]` : index);
            });
            return;
        }
        // Recursive call for nested objects
        else if ((0, isPlainObject_1.default)(value)) {
            Object.entries(value).forEach(([p, v]) => {
                traverse(v, key ? `${key}[${p}]` : p);
            });
            return;
        }
        // return for falsy values
        if (removeFalsy && [NaN, Infinity, -Infinity].includes(value))
            return;
        // Return if value is null
        if (removeNull && value === null)
            return;
        // Return if value is undefined
        if (removeUndefined && value === undefined)
            return;
        // Remove empty strings
        if (removeEmptyString && (0, isString_1.default)(value) && !value.trim())
            return;
        // Return if function
        if ((0, isFunction_1.default)(value))
            return;
        // Convert booleans to 0 1
        if (booleanAsNumber && (0, isBoolean_1.default)(value)) {
            value = +value;
        }
        // Convert date to ISO string
        if (dateToISOString && (0, isDate_1.default)(value)) {
            value = value.toISOString();
        }
        // Append to formData
        formData.append(key, value);
    };
    // Traverse the given object
    traverse(value);
    // return formData
    return formData;
};
exports.toFormData = toFormData;
